import { render, staticRenderFns } from "./ExAssignmentCard.vue?vue&type=template&id=5f23364c&scoped=true"
import script from "./ExAssignmentCard.vue?vue&type=script&lang=js"
export * from "./ExAssignmentCard.vue?vue&type=script&lang=js"
import style0 from "./ExAssignmentCard.vue?vue&type=style&index=0&id=5f23364c&prod&scoped=true&lang=css"
import style1 from "./ExAssignmentCard.vue?vue&type=style&index=1&id=5f23364c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23364c",
  null
  
)

export default component.exports